@if (activeSectionRoute$ | async) {}
@if (routerEvents$ | async) {}

<div class="st-mobile-left-menu">
  <div class="st-mobile-left-menu-top-section">
    <img
      class="menu-logo"
      src="../../../../../../assets/images/Logo.svg"
      alt=""
    />
    <div class="st-mobile-left-menu-top-section-navigators">
      @for (nav of dashboardRoutes(); track $index) {
        <a
          (click)="selectSection(nav)"
          [ngClass]="{ active: (activeSectionRoute$ | async)?.id === nav.id }"
          class="body-medium-bold"
        >
          <em [class]="nav.iconClass"></em>
          <span>{{ nav.name }}</span>
          @if (nav.children.length) {
            <em class="ph ph-caret-right ml-auto"></em>
          }
        </a>
      }
      @for (nav of navigationList(); track $index) {
        <a
          (click)="selectSection(nav)"
          [ngClass]="{ active: (activeSectionRoute$ | async)?.id === nav.id }"
          class="body-medium-bold"
        >
          <em [class]="nav.iconClass"></em>
          <span>{{ nav.name }}</span>
          @if (nav.children.length) {
            <em class="ph ph-caret-right ml-auto"></em>
          }
        </a>
      }
      @if (tools().length && !hideTools()) {
        <a
          (click)="openTools()"
          class="body-medium-bold"
        >
          <em class="ph ph-circles-four"></em>
          <span>Apps</span>
          <em class="ph ph-caret-right ml-auto"></em>
        </a>
      }
    </div>
  </div>
  <div class="st-mobile-left-menu-bottom-section">
    @if (isStandAlonePortal()) {
      <a
        (click)="selectSection(settingsRoutes())"
        [ngClass]="{
          active: (activeSectionRoute$ | async)?.id === settingsRoutes().id,
        }"
        class="body-medium-bold"
      >
        <em [class]="settingsRoutes().iconClass"></em>
        <span>{{ settingsRoutes().name }}</span>
        @if (settingsRoutes().children.length) {
          <em class="ph ph-caret-right ml-auto"></em>
        }
      </a>
    } @else {
      <a
        (click)="settingsMenu.toggle($event)"
        [ngClass]="{
          active: (activeSectionRoute$ | async)?.id === settingsRoutes().id,
        }"
        class="body-medium-bold"
      >
        <em [class]="settingsRoutes().iconClass"></em>
        <span>{{ settingsRoutes().name }}</span>
        @if (settingsRoutes().children.length) {
          <em class="ph ph-caret-right ml-auto"></em>
        }
      </a>
      <p-menu
        #settingsMenu
        [model]="settingMenuItems()"
        [popup]="true"
        appendTo="body"
      />
    }
    <a
      class="profile-btn cursor-pointer"
      (click)="profileMenu.toggle($event)"
      [ngClass]="{ active: isStaticButtonActive() === 'profile' }"
    >
      <img
        [src]="userImage()"
        alt=""
      />
      <span class="body-medium-bold">{{ userName() }}</span>
    </a>
    <p-menu
      #profileMenu
      [model]="profileMenuItems()"
      [popup]="true"
      appendTo="body"
    />
  </div>
</div>
